import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const money = (
  value: number | string | null | undefined,
  currency = "INR",
) => {
  if (value === null || value === undefined || value === "")
    return "NOT AVAILABLE";
  return new Intl.NumberFormat(currency === "INR" ? "en-IN" : "en", {
    style: "currency",
    currency,
    maximumFractionDigits: 2,
  }).format(Number(value));
};

export const displayDate = (
  value: string | null | undefined,
  includeTime = false,
) =>
  value
    ? new Intl.DateTimeFormat(
        "en-IN",
        includeTime
          ? { dateStyle: "medium", timeStyle: "short" }
          : { dateStyle: "medium" },
      ).format(new Date(value))
    : "—";

export const titleCase = (value: string | null | undefined) =>
  String(value || "")
    .replaceAll("_", " ")
    .replace(/\b\w/g, (character) => character.toUpperCase());
